<template>
  <div class="container search-block">
    <div class="box">
      <div class="notice">*Report is scheduled to update at 9am everyday.</div>
      <div>
        <input type="date" id="date_picker">
      </div>
      <div class="genertae-block">
        <div class="button-wrapper">
          <a class="button is-link" @click="$emit('search', dateStr)">Generate</a>
        </div>
        <div class="button-wrapper">
          <a class="button is-warning" @click="$emit('refetch', dateStr)">Refetch Data</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bulmaCalendar from '../../node_modules/bulma-calendar/dist/js/bulma-calendar.min.js';

export default {
  name: 'SearchBlock',
  data: function() {
    return {
      date: null,
    }
  },
  computed: {
    dateStr: function() {
      if (!this.date) {
        return '';
      }

      const yearStr = String(this.date.getFullYear());

      const month = this.date.getMonth() + 1;
      let monthStr = '';
      if (month < 10) {
        monthStr = `0${month}`;
      } else {
        monthStr = `${month}`;
      }

      const day = this.date.getDate();
      let dayStr = '';
      if (day < 10) {
        dayStr = `0${day}`;
      } else {
        dayStr = `${day}`;
      }

      return `${yearStr}${monthStr}${dayStr}`;
    }
  },
  mounted() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    this.date = yesterday;

    const options = {
      startDate: yesterday,
      type: 'date',
      color: 'info',
      maxDate: yesterday,
    }

    bulmaCalendar.attach('[type="date"]', options);
    const element = document.querySelector('#date_picker');
    if (element) {
      // bulmaCalendar instance is available as element.bulmaCalendar
      element.bulmaCalendar.on('select', datepicker => {
        this.date = new Date(datepicker.data.value());
      });
    }
  }
}
</script>

<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/bulma/0.7.5/css/bulma.min.css";
@import '../../node_modules/bulma-calendar/dist/css/bulma-calendar.min.css';

.search-block {
  border: 1px solid transparent;
  border-radius: 4px;
  border-color: #ddd;
}

.genertae-block {
  padding-top: 1rem;
  display: flex;
  justify-content: center;
}

ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.button-wrapper {
  margin: 0 10px;
}

.notice {
  text-align: left;
  color: #666;
}

</style>
